<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Peringkat Saya</div>
		</div>
		<div class="mt-5">
			<template v-if="!loading">
				<v-row class="ml-0" v-if="rankQualified.length > 0">
					<v-col cols="12" sm="6" md="6" lg="4" class="pl-0 pb-0 flex-stretch" v-for="rank in rankQualified" :key="rank.rank_qualified_id">
						<v-card class="elevation-0 rounded-xl hover-shadow fill-height" style="position: relative;" :class="(rank.rank_qualified_is_qualified == '0') ? 'unqualified' : 'qualified'">
							<v-tooltip bottom v-if="rank.rank_qualified_is_qualified == '1'">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										color="primary"
										elevation="2"
										fab
										rounded
										class="btn-download"
										:loading="loadingSave"
										:disabled="loadingSave"
										v-bind="attrs"
										v-on="on"
										@click="saveToImage(rank, myProfile, 'card-' + myProfile.member_network_code + '-' + rank.rank_qualified_rank_title.toLowerCase())"
									>
										<v-icon dense color="dark">mdi-download</v-icon>
									</v-btn>
								</template>
								<span>Simpan Gambar</span>
							</v-tooltip>
							<div class="d-flex flex-wrap">
								<v-col cols="12" class="d-flex flex-column align-center fill-height pa-4">
									<div class="d-flex flex-column align-center fill-height" style="height: 23.55rem; width: 100%;" :id="'card-' + myProfile.member_network_code + '-' + rank.rank_qualified_rank_title.toLowerCase()">
										<v-img contain height="23.55rem" elevation="2" class="mx-0 px-0" :class="(rank.rank_qualified_is_qualified == '0') ? 'ico-unqualified' : 'ico-qualified'" :src="require(`/public/assets/peringkat/${ rank.rank_id }.png`)"></v-img>
										<div class="bottom-shadow"></div>
										<template v-if="Object.keys(myProfile).length > 0">
											<div class="rank-member-image">
												<template v-if="rank.rank_qualified_is_qualified == '1'">
													<img class="rounded-pill" :src="myProfile.member_image_url_encript ? myProfile.member_image_url_encript : require('/public/assets/image/profile-pict.png')" />
												</template>

												<template v-else>
													<img class="rounded-pill" :src="require('/public/assets/image/profile-pict.png')" />
												</template>
											</div>
											<div v-if="rank.rank_qualified_is_qualified == '1'" class="rank-member-name font-size-10" :class="(rank.rank_id == '5') ? 'rank5' : ''" :style="rank.rank_id == '5' ? 'top: 18.6rem' : 'top: 17.8rem'">{{ getName(myProfile.member_name) }}</div>
										</template>
									</div>
								</v-col>
								<v-col cols="12" class="pl-0 pt-3 align-start">
									<div class="pt-2 pb-2 px-3">
										<div class="font-size-12 cl-primary font-weight-600 text-uppercase">{{ rank.rank_qualified_rank_title }}</div>
									</div>
									<div class="d-flex flex-wrap pb-3">
										<v-col cols="12" class="pb-0 pt-1 d-flex flex-row align-center justify-space-between">
											<div class="font-size-9 cl-grey">Nominal Rank</div>
											<div class="font-size-9 cl-secondary font-weight-600 text-right">{{ rank.rank_qualified_rank_qualified_total_acc | toRupiah }}</div>
										</v-col>
										<v-col cols="12" class="pb-0 pt-1 d-flex flex-row align-center justify-space-between">
											<div class="font-size-9 cl-grey">Tanggal Qualified</div>
											<div class="font-size-9 cl-grey font-weight-600 text-right">{{ rank.rank_qualified_datetime | toDate }}</div>
										</v-col>
									</div>
								</v-col>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="rankQualified.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
								<NoData></NoData>
								<div class="pt-3 text-center primary--text">Tidak ada data yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>

				<div class="mt-3" v-if="rankQualified.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="rankQualifiedPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ rankQualifiedPagination.total_display }} data dari total {{ rankQualifiedPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="list_limit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="red darken-3" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>

				<!-- <div id="print-card">
					<template v-if="dataCard">
						<v-img contain height="35rem" width="35rem" elevation="2" class="rounded-xl mx-auto" :src="require(`/public/assets/peringkat/${dataCard.rank_id}.png`)"></v-img>

						<template v-if="Object.keys(myProfile).length > 0">
							<div class="rank-info">
								<div class="rank-member-image">
									<v-img height="13.5rem" width="14rem" class="rounded-pill" :src="myProfile.member_image_url_encript ? myProfile.member_image_url_encript : require('/public/assets/image/profile-pict.png')"></v-img>
								</div>
								<div class="rank-member-name font-size-14" :style="dataCard.rank_id == '5' ? 'top: 24.5rem' : 'top: 23.6rem'" style="font-size: 16pt;">{{ getName(myProfile.member_name) }}</div>
							</div>
						</template>
					</template>
				</div> -->

				<!-- <div id="print-card-view"></div> -->
			</template>

			<template v-else>
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</template>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import html2canvas from 'html2canvas';
// import * as htmlToImage from 'html-to-image';
// import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';

export default {
	components: {},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			list_limit: [ '10', '20', '50', '100' ],
			dataCard: null,
			loadingSave: false
		}
	},
	computed: {
		...mapState('peringkat', ['rankQualified', 'rankQualifiedPagination']),
		...mapState('profil', ['myProfile']),
	},
	methods: {
		...mapActions('peringkat', ['getRankQualified']),
		...mapActions('profil', ['getProfileMitra']),

		capitalize(word) {
			if (word !== '' || word.length > 0) {
				let strWord = word.toLowerCase()
				return strWord
					.split('')
					.map((letter, index) =>
						index ? letter.toLowerCase() : letter.toUpperCase(),
					)
					.join('');
      } else {
				return ''
			}
    },
		getName(name) {
			let name_split = name.split(" ");
			let name_true = ''
			if (name_split.length > 1) {
				if (name_split.length > 2) {
					if (name_split[0].length == 0) {
						const lastname = (name_split[2] != '') ? ' ' + this.capitalize(name_split[2]) : ''
						name_true = this.capitalize(name_split[1]) + lastname
					} else {
						const lastname = (name_split[1] != '') ? ' ' + this.capitalize(name_split[1]) : ''
						name_true = this.capitalize(name_split[0]) + lastname
					}
				} else {
					const lastname = (name_split[1] != '') ? ' ' + this.capitalize(name_split[1]) : ''
					name_true = this.capitalize(name_split[0]) + lastname
				}
			} else {
				name_true = this.capitalize(name_split[0])
			}
			return name_true
		},
		async getData() {
			this.loading = true
			await this.getProfileMitra()
			this.getRankQualified(this.queryString({ limit:this.limit, page: this.page, params:this.params })).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		saveToImage(rank, profile, id) {
			// var nodeView = document.getElementById('print-card-view');
			// var node = document.getElementById('print-card');
			this.loadingSave = true
			var node = document.getElementById(id);
			var member = profile
			this.dataCard = rank
					
			setTimeout(() => {
				html2canvas(node, { scale: 4 }).then(canvas => {
					// nodeView.appendChild(canvas)
					this.saveAs(canvas.toDataURL(), 'peringkat_' + rank.rank_qualified_rank_title.toLowerCase() + '_' + member.member_network_code + '.png');
				});

				// htmlToImage.toPng(node)
					// .then(function (dataUrl) {
						// var img = new Image();
						// img.setAttribute('crossOrigin', 'anonymous');
						// img.setAttribute('class', 'saveImage');
						// img.src = dataUrl;
						// // console.log('htmlToImage', img.src); // eslint-disable-line
						// nodeView.appendChild(img);

						// var a = document.createElement("a"); //Create <a>
						// // a.href = "data:image/png;base64," + img.src; //Image Base64 Goes here
						// a.href = img.src; //Image Base64 Goes here
						// a.download = 'peringkat_' + rank.rank_qualified_rank_title.toLowerCase() + '_' + member.member_network_code + '.png'; //File name Here
						// a.click(); //Downloaded file
					// })
					// .catch(function (error) {
					// 	console.error('oops, something went wrong!', error); // eslint-disable-line
					// });

					// setTimeout(() => {
					// 	this.dataCard = null
					// }, 2000);
			}, 6000);

		},
		saveAs(uri, filename) {
			var link = document.createElement('a');

			if (typeof link.download === 'string') {
				link.href = uri;
				link.download = filename;
				document.body.appendChild(link);

				//simulate click
				link.click();

				//remove the link when done
				document.body.removeChild(link);
			} else {
				window.open(uri);
			}

			this.loadingSave = false
		}

	},
	created(){
		this.$store.dispatch('setPageTitle', `Peringkat Saya`)
		this.getData()
	}
};
</script>

<style scoped>
.rank-member-image {
	position: absolute;
	top: 3.9rem;
	margin-left: -4px;
	/* left: 122px; */
}
.rank-member-image img {
	width: 10rem;
	height: 10rem;
}
.rank-member-name {
	position: absolute;
	color: #000;
	font-weight: bold;
}

#print-wrapper {
	display: block;
	width: 35rem;
}

.btn-download {
	display: block;
	position: absolute;
	top: 5px;
	left: 5px;
	z-index: 10;
	border-radius: 100%;
}

#print-card-view {
	position: relative;
	width: 35rem;
	bottom: 0px;
	left: 0;
	z-index: 10;
}

#print-card {
	width: 560px;
	border-radius: 4px;
	overflow: hidden;
	position: relative;
	/* visibility: hidden; */
	/* left: -1000px; */
}

#print-card .rank-info {
	display: flex;
	width: 100%;
	height: 100%;
	text-align: center;
	position: absolute;
	z-index: 10;
	top: 24px;
	left: -2px;
	justify-content: center;
}

.saveImage {
	display: none;
}

.ico-unqualified {
	filter: grayscale(1)!important;
	opacity: 0.7!important;
}

.unqualified {
	filter: grayscale(1)!important;
	opacity: 0.75!important;
}

.unqualified:before {
	content: '';
	position: absolute;
	width: 300px;
	height: 300px;
	background: url('/assets/image/unqualified.png') center center no-repeat;
	background-size: cover;
	top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
	z-index: 10;
}

@media (max-width: 399px) {
	.rank-member-name {
		margin-top: -16px;
	}

	.rank-member-name.rank5 {
		margin-top: -19px;
	}
}

@media (min-width: 400px) and  (max-width: 599px) {
	.rank-member-name {
		margin-top: -3px;
	}

	.rank-member-name.rank5 {
		margin-top: -6px;
	}
}

@media (min-width: 768px) and (max-width: 991.98px) {
	.rank-member-name {
		margin-top: -5px;
	}
}

@media (min-width: 1200px) and (max-width: 1399.98px) {
	.rank-member-name {
		margin-top: -18px;
	}

	.rank-member-name.rank5 {
		margin-top: -22px;
	}
}

@media (min-width: 1400px) and (max-width: 1499.98px) {
	.rank-member-name {
		margin-top: -18px;
	}

	.rank-member-name.rank5 {
		margin-top: -22px;
	}
}
</style>